<!-- Skip link - accessible navigation bypass -->
<chef-skip-link></chef-skip-link>

<app-header [options]="headerFooterOptions()"></app-header>
<!-- Stencil notifications -->
<chef-notification></chef-notification>

<!-- Stencil spinner -->
<chef-spinner></chef-spinner>

<main id="main">
  <router-outlet></router-outlet>
</main>

<!-- Footer -->
<app-footer [options]="headerFooterOptions()"></app-footer>

<!-- Stencil back-to-top -->
<chef-back-to-top></chef-back-to-top>
